import {
  Edit,
  ListButton,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { HTMLInput } from "@/inputs/HTMLInput";
import { ClientAppInput } from "@/modules/clientApps";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
  </TopToolbar>
);

export const MailSubjectEdit = () => {
  return (
    <Edit actions={<EditActions />} mutationMode="pessimistic">
      <SimpleForm toolbar={<EditToolbar />}>
        <ClientAppInput source="clientApp" validate={required()} />
        <TextInput type="text" source="title" validate={[required()]} />
        <TextInput type="text" source="type" validate={[required()]} />
        <HTMLInput source="body" validate={[required()]} />
      </SimpleForm>
    </Edit>
  );
};
